const SOIL_TYPES = [
  'Arcilloso',
  'Arenoso',
  'Limoso',
  'Franco',
  'Franco Arenoso',
  'Franco Limoso',
  'Franco Arcilloso',
  'Franco Arcillo Arenoso',
  'Franco Arcillo Limoso',
  'Arcillo Arenoso',
  'Arcillo Limoso',
  'Areno Francoso',
];

const INTERVALS = [
  { key: '1-day', label: '1 día' },
  { key: '1-week', label: '1 semana' },
  { key: '2-weeks', label: '2 semanas' },
  { key: '1-month', label: '1 mes' },
  { key: '3-months', label: '3 meses' },
  { key: '6-months', label: '6 meses' },
] as const;

interface CultivationCycle {
  name: string;
  startDate: string;
  endDate: string;
  id: string;
  varietyName?: string;
  varietySpecies?: string;
}

// eslint-disable-next-line import/prefer-default-export
export { SOIL_TYPES, INTERVALS, CultivationCycle };
